'use strict';
module.exports = function (x) {
	var type = typeof x;
	return x !== null && (type === 'object' || type === 'function');
};



//////////////////
// WEBPACK FOOTER
// ./~/is-obj/index.js
// module id = 392
// module chunks = 0